import * as React from "react";
import { FC } from "react";
import "./Checkbox.scss";

export interface ICheckbox {
    label: string;
    subTitle?: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
}
export const Checkbox: FC<ICheckbox> = (props) => (
    <div className="checkmark-element">
        <label className="checkmark-container">
            {props.label}
            <input type="checkbox" checked={props.checked} onChange={(e) => props.onChange(e.target.checked)}></input>
            <span className="checkmark"></span>
        </label>
        {props.subTitle ? <div className="checkmark-subtitle">{props.subTitle}</div> : null}
    </div>
);
